import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

/**
 * Trade Entity Definition
 *
 * Defines the structure and validation rules for trade data imports.
 * This template is used for mapping external data to the WealthBee trade format.
 *
 * @type {ImportTemplateField[]} Array of field definitions for trade imports
 */
export const TransactionWithInstrument: ImportTemplateField[] = [
  {
    toField: "instrumentKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "name",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentType",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentClass",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "round",
    fromField: "",
    dataType: DataType.integer,
    required: true,
  },
  {
    toField: "transactionKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "transactionDate", // Date when the trade was executed
    fromField: "",
    dataType: DataType.date,
    required: true, // Trade date is essential for accounting and reporting
  },
  {
    toField: "baseAmount", // Base amount of the transaction
    fromField: "",
    dataType: DataType.decimal,
    required: true, // Amount is required for valuation
    precision: 2, // Two decimal places for currency precision
  },
  {
    toField: "currency", // Currency of the transaction
    fromField: "",
    dataType: DataType.string,
    required: true, // Currency is required for proper accounting
  },
  {
    toField: "quantity", // Quantity of securities traded
    fromField: "",
    dataType: DataType.decimal,
    required: true, // Quantity is required for position calculations
    precision: 2, // Allow for fractional shares
  },
  {
    toField: "accountKey", // Account identifier
    fromField: "",
    dataType: DataType.string,
    required: true, // Account key is required to identify the account
  },
  {
    toField: "transactionType", // Type of transaction (e.g., Dividend)
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "description", // Description or notes about the transaction
    fromField: "",
    dataType: DataType.string,
    required: false,
  },
];
